import React, { useContext, useEffect, useRef, useState } from 'react'
import SideBarLayout from '../../layouts/SideBarLayout'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fa0, fa1, fa2, fa3, fa4, fa6, fa7, faClose, faList, faMap, faMapLocationDot, faMapPin, faPaperPlane, faPlus, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import Card from '../../components/Card'
import { Link, useNavigate } from 'react-router-dom'
// import defaultMarkerIconPng from "leaflet/dist/images/marker-icon.png";
import defaultMarkerIconPng from "../../assets/marker.png";
import IconButton from '../../components/IconButton'
import { toast } from 'react-toastify'
import axios from 'axios'
import authService from '../../authentication'
import instance from '../../api/client'
import * as Yup from 'yup'
import ProjectsContext from '../../contexts/ProjectsContext'
import HomeSubmit from '../../components/formik/HomeSubmit'
import HomeInput from '../../components/formik/HomeInput'
import HomeTextArea from '../../components/formik/HomeTextArea'
import { Formik } from 'formik'
import SelectorInput from '../../components/SelectorInput'
import AppContext from '../../contexts/AppContext'
import { LayersControl, MapContainer, Popup, TileLayer, Marker } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet'
import { useMapEvents } from 'react-leaflet';


const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("Name"),
  description: Yup.string().required().label("Description"),
});

export default function Projects() {
  const { location, isMap, setIsMap, projects, setProjects, mapBtnClass, setMapBtnClass, listBtnClass, setListBtnClass, toggleUnSelectedClass, toggleSelectedClass } = useContext(ProjectsContext)
  const [showProjectForm, setShowProjectForm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedSchemaName, setSelectedSchemaName] = useState('')
  const [schemas, setSchemas] = useState([])
  const navigate = useNavigate()
  const { openModal, user, setNavHeaderText } = useContext(AppContext)

  const [lon, setLon] = useState(50.879)
  const [lat, setLat] = useState(4.6997)

  const schemaNames = schemas?.map((schema) => schema.name)
  // const selectedSchema = schemas?.find((schema) => schema.name === selectedSchemaName)

  useEffect(() => {
    if (location?.state?.create) {
      setShowProjectForm(true)
    }
  }, [])

  useEffect(() => {
    setNavHeaderText('Projects')
  }, [])

  // Creating project
  const onSubmit = async (form, { resetForm }) => {
    toast.info(`Creating Project`, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000
    });

    if (!selectedSchemaName) {
      toast.info(`No schema selected, cannot submit`, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000
      });
      return
    }

    try {
      const { data: d, status } = await instance.post('/projects/create-project', { ...form, longitude: lon, latitude: lat }, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        const { data, status } = await setActiveSchema(d)
        toast.success(`Project created`, {
          position: toast.POSITION.TOP_CENTER
        });
        console.log('project: ', data);
        const newData = { ...data, creator: user.sub }
        setProjects([...projects, newData])
        setShowProjectForm(false)
        resetForm();
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  };

  const updateActiveSchema = async (projectId) => {
    setLoading(true)
    
  }

    
  const setActiveSchema = async (project) => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/projects/set-active-schema/${project.code}/${selectedSchemaName}`, {}, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      toast.success(`Project Schema: ${selectedSchemaName}`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false)
      return { data, status }
    } catch (error) {
      toast.error(`Failed to add to ${selectedSchemaName} to project\n${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
      setLoading(false)
      return error
    }
  }

  const deleteProject = async (project) => {
    setLoading(true)
    toast.info(`trying to delete..`, {
      position: toast.POSITION.TOP_CENTER
    });
    try {
      const { data, status } = await instance.delete(`/projects/delete-project/${project.code}`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        const newProjects = projects.filter((pro) => pro.code !== project.code)
        setProjects(newProjects)
        toast.success(`Project deleted`, {
          position: toast.POSITION.TOP_CENTER
        });
        setLoading(false)
        return status
      } else {
        console.log(status);
        setLoading(false)
        return status
      }
    } catch (error) {
      setLoading(false)
      toast.error(`${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
      return error
    }
  }

  const getSchemas = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.get(`/prioritize/get-all-schemas`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      if (status == 200) {
        setSchemas(data);
        setSelectedSchemaName(data[0].name)
        if (!data.length) {
          toast.error(`Please create a schema from the 'Models' (on the side menu) before proceeding`, {
            position: toast.POSITION.TOP_CENTER
          });
        }
        setLoading(false)
        return status
      } else {
        console.log(status);
        setLoading(false)
        return status
      }
    } catch (error) {
      setLoading(false)
      return error
    }
  }


  useEffect(() => {
    getSchemas()
  }, [])

  const mapRef = useRef();

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setView([lat, lon]);
    }
  }, [lat, lon]);

  const ClickHandler = () => {
    useMapEvents({
      click(e) {
        setLat(e.latlng.lat);
        setLon(e.latlng.lng);
      },
    });

    return null;
  };

  console.log(projects);

  return (
    <>
      <div className='flex items-center bg-white'>
        {
          showProjectForm ?
            <div className='w-full flex justify-end px-32'>
              <div onClick={() => setShowProjectForm(false)} className='h-8 w-8 flex cursor-pointer justify-center items-center rounded-lg border-2 border-gray-300 hover:text-white hover:bg-gray-700'>
                <FontAwesomeIcon icon={faClose} size='1x' />
              </div>
            </div>
            :
            <div className='w-full px-10 pt-5'>
              <IconButton icon={faPlusCircle} size={'lg'} title={'New Project'} onClick={() => { setShowProjectForm(true) }} />
            </div>
        }
        {
          !showProjectForm && <div style={{ fontFamily: 'Roboto' }} className='flex w-full text-md justify-end px-16 sticky top-2 h-8'>
            <button onClick={(e) => {
              if (listBtnClass != toggleSelectedClass) {
                setListBtnClass(toggleSelectedClass)
                setMapBtnClass(toggleUnSelectedClass)
                setIsMap(false)
              }
            }} className={listBtnClass}>
              <FontAwesomeIcon icon={faList} className='mr-1' />
              list
            </button>
            <button onClick={(e) => {
              if (mapBtnClass != toggleSelectedClass) {
                setMapBtnClass(toggleSelectedClass)
                setListBtnClass(toggleUnSelectedClass)
                setIsMap(true)
              }
            }} className={mapBtnClass}>
              map
              <FontAwesomeIcon icon={faMapLocationDot} className='ml-1' />
            </button>
          </div>
        }
      </div>

      {
        !showProjectForm ?
          <div className="flex-1 mx-5 px-5 rounded">
            <div style={{ display: isMap ? 'none' : 'grid' }} className=" grid grid-cols-2 gap-2 px-5 items-center">
              {projects.map((project) => (<Card onDelete={() => {
                openModal('Delete project?', `Are you sure you want to delete project "${project.name}"`, () => deleteProject(project))
              }} nodate onClick={() => { navigate('/project-info/bowties', { state: { project: project } }) }} title={project.name} className={'bg-theme'} />))}
            </div>
            {isMap &&
              <MapContainer style={{
                height: 500,
                width: '100%',
              }}
                minZoom={2} // just added so you cannot go out of area
                maxBounds={[[-90, -180], [90, 180]]}
                zoom={3}
                maxZoom={8}
                center={projects.length ? projects[projects.length - 1].location.coordinates : [30.879, 8.6997]}
              >
                <LayersControl position="topright">
                  <TileLayer
                    url={'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'}
                    attribution={'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'}
                  />

                  <LayersControl.Overlay name="openstreetmap">
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                  </LayersControl.Overlay>
                  <LayersControl.Overlay name="openstreetmap(french)">
                    <TileLayer
                      url={'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png'}
                      attribution={'&copy; OpenStreetMap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}
                    />
                  </LayersControl.Overlay>
                  <LayersControl.Overlay name="world imagery">
                    <TileLayer
                      url={'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'}
                      attribution={'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'}
                    />
                  </LayersControl.Overlay>

                </LayersControl>
                {
                  projects.map((project) => (
                    <Marker position={project.location.coordinates} icon={new Icon({ iconUrl: defaultMarkerIconPng, iconSize: [25, 41], iconAnchor: [12.5, 41] })}>
                      <Popup>
                        <div className='font-semibold capitalize mt-2 mb-1'>{project.name}</div>
                        <div className='flex justify-center items-center'>
                          (<div>{project.location.coordinates[0]}</div>, <div>{project.location.coordinates[1]}</div>)
                        </div>
                        <IconButton boxClassName={'w-full mt-2'} onClick={() => { navigate('/project-info/bowties', { state: { project: project } }) }} icon={faPaperPlane} />
                      </Popup>
                    </Marker>
                  ))
                }
              </MapContainer>
            }
          </div> :
          schemaNames.length ?
            <Formik
              initialValues={{ name: '', description: '' }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              <>
                <div className='w-2/3 mx-auto p-5 bg-white shadow-lg border-slate-300 pb-10'>
                  <div class="mt-2 w-full gap-5">
                    <HomeInput name={'name'} label={'name'} placeholder={'New Project'} type={'text'} />
                  </div>
                  <div className="mt-2">
                    <HomeTextArea name={'description'} label={'description'} placeholder={'Tell us about the project'} />
                  </div>
                  <div className="mt-2">
                    <SelectorInput label={'Select schema (for prioritzation model)'} onChange={(e) => {
                      setSelectedSchemaName(e.target.value)
                    }} options={schemaNames} value={selectedSchemaName} />
                  </div>
                  <div className='grid grid-cols-2 w-full gap-2'>
                    <div class="my-3">
                      <label className={`hidden md:block my-2 font-bold md:font-semibold text-md md:text-center text-slate-700 uppercase`} for="latitude">
                        Latitude
                      </label>
                      <input value={lat} onChange={(e) => {
                        if (!isNaN(e.currentTarget.valueAsNumber)) {
                          setLat(e.currentTarget.valueAsNumber)
                        }
                      }} class="text-center md:mb-2 md:shadow-b appearance-none hover:outline-none border-b-2 border-y-slate-400 md:rounded-lg hover:md:border-2 hover:border-sky-400  w-full py-2 mt-2 px-3 text-gray-800 
          leading-tight focus:outline-none focus:shadow-outline" id="latitude" type="number" placeholder="2.002126" />
                    </div>
                    <div class="my-3">
                      <label className={`hidden md:block my-2 font-bold md:font-semibold text-md md:text-center text-slate-700 uppercase`} for="longitude">
                        Longitude
                      </label>
                      <input value={lon} onChange={(e) => {
                        if (!isNaN(e.currentTarget.valueAsNumber)) {
                          setLon(e.currentTarget.valueAsNumber)
                        }
                      }} class="text-center md:mb-2 md:shadow-b appearance-none hover:outline-none border-b-2 border-y-slate-400 md:rounded-lg hover:md:border-2 hover:border-sky-400  w-full py-2 mt-2 px-3 text-gray-800 
          leading-tight focus:outline-none focus:shadow-outline" id="longitude" type="number" placeholder="-1.311123" />
                    </div>
                  </div>
                  <MapContainer ref={mapRef}
                    style={{
                      height: 250,
                      width: '100%',
                    }}
                    // minZoom={3} // just added so you cannot go out of area
                    zoom={3}
                    center={[lat, lon]}
                  >
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={[lat, lon]} icon={new Icon({ iconUrl: defaultMarkerIconPng, iconSize: [25, 41], iconAnchor: [12.5, 41] })}>
                    </Marker>
                    <ClickHandler />
                  </MapContainer>
                  <div className='mt-10'>
                    <HomeSubmit theme text={'Create'} />
                  </div>
                </div>
              </>
            </Formik>
            : !loading && <div className='flex w-full justify-center'>No schema. Create one</div>
      }
    </>
  )
}
